import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class CheckinPassengerAdditionValidationService {
  /**
   * 個別入力チェック 名+姓の最大文字数を判定する
   * @param control 同行者(名)または同行者(姓)
   * @returns 55文字以下:null / それ以外:{ isNameOverDigits: true }
   */
  nameDigitsValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const firstName = control.get('firstName')?.value || '';
    const lastName = control.get('lastName')?.value || '';

    return firstName.length + lastName.length > 55 ? { isNameOverDigits: true } : null;
  };
}
